import { SVGAttributes } from 'react'

export function BellSimpleIcon(props: SVGAttributes<SVGSVGElement>) {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M8 2C6.067 2 4.5 3.567 4.5 5.5V7.5C4.5 8.552 4.105 9.561 3.396 10.311L2.75 11H13.25L12.604 10.311C11.895 9.561 11.5 8.552 11.5 7.5V5.5C11.5 3.567 9.933 2 8 2Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.5 11V11.5C6.5 12.328 7.172 13 8 13C8.828 13 9.5 12.328 9.5 11.5V11'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}


